import { useAppSelector, useAppDispatch } from "@/redux";
import { fetchProductsAsync } from "@/redux/slices/productSlice";

export default function useProduct() {
  const state = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();

  return {
    state,
    fetchProductsAsync: () => dispatch(fetchProductsAsync()),
  };
}
